<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body">
    <div class="flex-col gap-8">
      <label>{{ 'SUAS.ACCOUNT.DETAILS.DEVICE_EMAILS.TITLE' | translate }}</label>
      <div class="device-emails-channels">
        @for (channel of deviceEmailChannels; track channel.key) {
          <div class="device-emails-channel" [attr.data-channel]="channel.key">
            <div class="channel-label">{{ channel.label | translate }}</div>
            <div class="option-list">
              <div class="option-row" (click)="selectOrgDefault(channel.key)">
                <span
                  class="check-square"
                  [class.checked]="isOrgDefault(channel.key)"
                ></span>
                <div class="option-label">
                  {{ 'SUAS.ACCOUNT.DETAILS.DEVICE_EMAILS.ORG_DEFAULT' | translate }}
                </div>
              </div>
              @for (option of deviceEmailFrequencyOptions; track option.value) {
                <div
                  class="option-row"
                  (click)="toggleFrequency(channel.key, option.value)"
                >
                  <span
                    class="check-square"
                    [class.checked]="isChecked(channel.key, option.value)"
                  ></span>
                  <div class="option-label">{{ option.label | translate }}</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div class="description">
        {{ 'SUAS.ACCOUNT.DETAILS.DEVICE_EMAILS.ORG_DEFAULT_CAPTION' | translate }}
      </div>
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      [text]="'SUAS.COMMON.CANCEL' | translate"
      type="default"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      [text]="'SUAS.COMMON.SAVE' | translate"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
